module.exports = __webpack_public_path__ + "static/img/06033D_1_2_R_20210919_LC.02dfdf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/06033D_1_2_R_20210919_LC.png
// module id = Gu9m
// module chunks = 0